// 앱 상수
export const APP_NAME = '에코딜(EcoDeal)'
export const APP_VERSION = '1.0.0'

// 할인율 상수
export const DISCOUNT_RATES = {
  DEADLINE_MINIMUM: 40, // 마감할인 최소 40%
  RANDOM_SET_MINIMUM: 50, // 랜덤세트 최소 50%
  RESERVATION_MAXIMUM: 10, // 예약할인 최대 10%
} as const

// 수수료 상수
export const COMMISSION_RATES = {
  DEADLINE_DISCOUNT: 15, // 마감할인 15%
  RESERVATION_DISCOUNT: 6, // 예약할인 6%
  REGULAR_ORDER: 6, // 일반주문 6%
} as const

// 이미지 상수
export { DEFAULT_ECOPACK_IMAGE_URL, LEGACY_ECOPACK_IMAGE_URL } from './images'

// 주문 상태 라벨
export const ORDER_STATUS_LABELS = {
  PENDING: '결제 대기',
  ACCEPTED: '주문 접수',
  READY: '준비 완료',
  COMPLETED: '픽업 완료',
  CANCELLED: '취소됨',
  NOSHOW: '노쇼',
} as const

// 주문 타입 라벨
export const ORDER_TYPE_LABELS = {
  DEADLINE_DISCOUNT: '마감할인',
  RESERVATION_DISCOUNT: '예약할인',
  REGULAR_ORDER: '일반주문',
} as const

// 가게 유형 상수
export const STORE_TYPES = [
  { id: 'korean', label: '한식' },
  { id: 'chinese', label: '중식' },
  { id: 'japanese', label: '일식' },
  { id: 'western', label: '양식' },
  { id: 'bunsik', label: '분식' },
  { id: 'lunchbox', label: '도시락' }, // '치킨'에서 변경
  { id: 'salad', label: '샐러드' },   // '피자'에서 변경
  { id: 'buffet', label: '뷔페' },     // '햄버거'에서 변경
  { id: 'cafe', label: '카페' },
  { id: 'dessert', label: '디저트' },
  { id: 'bakery', label: '베이커리' },
  { id: 'tteok', label: '떡집' },
  { id: 'asian', label: '아시안' },
  { id: 'mexican', label: '멕시칸' },
  { id: 'etc', label: '기타' },
];

// 반응형 브레이크포인트
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
} as const

// 시간 관련 상수
export const TIME_CONSTANTS = {
  // (레거시) 마감할인 자동 취소 타임아웃: 현재 사용하지 않음
  DEADLINE_PENDING_TIMEOUT: 10 * 60 * 1000,
  
  // 주문 유형별 픽업 윈도우 (밀리초)
  PICKUP_WINDOWS: {
    DEADLINE_DISCOUNT: 'until_discount_end', // 마감할인 종료시간까지 (동적 계산)
    RESERVATION_DISCOUNT: 1 * 60 * 60 * 1000, // 1시간
    REGULAR_ORDER: 2 * 60 * 60 * 1000, // 2시간
  },
  
  // 예약할인 자동 취소 시간 (자정)
  RESERVATION_AUTO_CANCEL_TIME: '00:00',
  
  // NOSHOW 처리 체크 간격
  NOSHOW_CHECK_INTERVAL: 5 * 60 * 1000, // 5분
} as const

// 페이지 경로
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  BUYER: {
    HOME: '/buyer',
    FAVORITES: '/buyer/favorites',
    ORDERS: '/buyer/orders',
    PROFILE: '/buyer/profile',
  },
  SELLER: {
    HOME: '/seller',
    ORDERS: '/seller/orders',
    PRODUCTS: '/seller/products',
    PROFILE: '/seller/profile',
  },
  ADMIN: {
    HOME: '/admin',
    USERS: '/admin/users',
    RESTAURANTS: '/admin/restaurants',
    ORDERS: '/admin/orders',
    ANALYTICS: '/admin/analytics',
  },
} as const
